import { URL } from '@core/constants/url.constant';
import { ApiStreamValidate } from '@core/decorators/ApiStreamValidate.decorator';
import { apiStreamService } from '@core/services/ApiStream.service';
import { messageStreamResponseSchema } from '../schemas/flowChat.schema';
import type {
  TMessageStreamEvents,
  TFlowChatStreamRequest,
  TRestoreFlowChatStreamRequest
} from '../models/flowChat.model';

class AbcloudzStreamService {
  @ApiStreamValidate(messageStreamResponseSchema)
  public chatMsgStream$({ flowId, dto, options }: TFlowChatStreamRequest) {
    return apiStreamService.post$<TMessageStreamEvents>({
      url: `${URL.flowsChatStream}/${flowId}/chat/messages/stream`,
      options: {
        ...options,
        body: JSON.stringify({
          ...dto,
          baseUrl: location.origin
        })
      }
    });
  }

  @ApiStreamValidate(messageStreamResponseSchema)
  public restoreChatStream$({ flowId, sessionId, options }: TRestoreFlowChatStreamRequest) {
    return apiStreamService.get$<TMessageStreamEvents>({
      url: `${URL.flowsChatStream}/${flowId}/chat/sessions/${sessionId}/subscribe`,
      options: {
        ...options
      }
    });
  }
}

const abcloudzStreamService = new AbcloudzStreamService();

export { abcloudzStreamService };
